import { useTheme, CSSObject } from '@core-ui/react-stitch';

const drawerTopSectionStyles = (): CSSObject => {
  const theme = useTheme();

  return ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem',
    borderBottom: `1px solid ${theme.color.gray20}`,
  });
};

const drawerMiddleSectionStyles: CSSObject = {
  width: '100%',
  overflowY: 'scroll',
};

const dashboardSelectContainerStyles: CSSObject = {
  '& label select': {
    '@media only screen and (max-width: 460px)': {
      fontSize: '.75rem',
    },
  },
  '& .all-size-indent select': {
    '@media only screen and (max-width: 525px)': {
      paddingLeft: '0px',
    },
  },
  '& .value-size-indent select': {
    '@media only screen and (max-width: 525px)': {
      textIndent: '0%',
    },
  },
};

export {
  drawerTopSectionStyles,
  drawerMiddleSectionStyles,
  dashboardSelectContainerStyles,
};
